// extracted by mini-css-extract-plugin
export default {"outRightMarket":"styles_outRightMarket__MY3za","outRightMarket__border":"styles_outRightMarket__border__OlyVT","outRightMarketMobile":"styles_outRightMarketMobile__mERo-"};